import { useEffect, useRef, useState } from "react";
import styles from './index.module.scss';

const Digit = (p: { value: number, size?: number }) => {
    const { value, size = 16 } = p;
    const lineHeightRatio = 1.4;
    const lineHeight = lineHeightRatio * size;
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.style.transform = `translate3d(0, -${value * lineHeight}px, 0)`
        }
    }, [value]);
    return (
        <div>
            <div style={{
                height: lineHeight
            }}  className={styles['digit-container']}>
                <div ref={containerRef} className={styles.inner}>
                    {
                        new Array(10).fill(0).map((_, index) => {
                            return <div key={index} className={styles.digit} style={{ height: lineHeight, fontSize: size }}>
                                {index}
                            </div>
                        })
                    }
                </div>

            </div>
        </div>
    )
}

export default function Oclock() {
    const [d, setD] = useState(new Date());
    useEffect(() => {
        const t = setTimeout(() => {
            setD(new Date());
        }, 1000);
        return () => {
            clearTimeout(t)
        }
    }, [d]);
    const Y = d.getFullYear();
    const M = d.getMonth() + 1;
    const D = d.getDate();
    const h = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    const [y1, y2, y3, y4] = Array.from(String(Y));
    const month1 = M > 9 ? 1 : 0
    const month2 = M % 10;
    const d1 = D > 9 ? String(D)[0] : '0';
    const d2 = D > 9 ? String(D)[1] : String(D);
    const h1 = h > 9 ? String(h)[0] : '0';
    const h2 = h > 9 ? String(h)[1] : String(h);
    const m1 = m > 9 ? String(m)[0] : '0';
    const m2 = m > 9 ? String(m)[1] : String(m);
    const s1 = s > 9 ? String(s)[0] : '0';
    const s2 = s > 9 ? String(s)[1] : String(s);
    return (
        <div className={styles.container}>
            <Digit value={Number(y1)} />
            <Digit value={Number(y2)} />
            <Digit value={Number(y3)} />
            <Digit value={Number(y4)} />
            <div className={styles.splitor}>-</div>
            <Digit value={Number(month1)} />
            <Digit value={Number(month2)} />
            <div className={styles.splitor}>-</div>
            <Digit value={Number(d1)} />
            <Digit value={Number(d2)} />
            <div className={styles.splitor} style={{ paddingRight: '1em' }}></div>
            <Digit value={Number(h1)} />
            <Digit value={Number(h2)} />
            <div className={styles.splitor}>:</div>
            <Digit value={Number(m1)} />
            <Digit value={Number(m2)} />
            <div className={styles.splitor}>:</div>
            <Digit value={Number(s1)} />
            <Digit value={Number(s2)} />
        </div>
    )
}